export default "__VITE_ASSET__C5ja0MNj__"